import { SerializedCacheEntry } from './Cache.interface';

export class CacheEntry<T> {
    data: Promise<T>;
    time: number;

    constructor(data: Promise<T>) {
        this.data = data;
        this.time = Date.now();
    }

    hasExpired(expirationTime: number): boolean {
        return Date.now() - this.time > expirationTime;
    }

    serialize(): Promise<SerializedCacheEntry<T>> {
        return this.data.then((d) => ({ data: d, time: this.time }));
    }

    deserialize(serialized: SerializedCacheEntry<T>): void {
        const dataPromise = new Promise<T>((resolve) => {
            resolve(serialized.data);
        });
        this.data = dataPromise;
        this.time = serialized.time;
    }
}
